type PromiseWithTry = PromiseConstructor & {
  try?: <TArgs extends unknown[], TResult>(
    callback: (...args: TArgs) => TResult | PromiseLike<TResult>,
    ...args: TArgs
  ) => Promise<Awaited<TResult>>;
};

const PromiseConstructorWithTry = Promise as PromiseWithTry;

if (typeof PromiseConstructorWithTry.try !== "function") {
  Object.defineProperty(PromiseConstructorWithTry, "try", {
    configurable: true,
    writable: true,
    value: <TArgs extends unknown[], TResult>(
      callback: (...args: TArgs) => TResult | PromiseLike<TResult>,
      ...args: TArgs
    ) =>
      new Promise<Awaited<TResult>>((resolve) => {
        resolve(callback(...args) as Awaited<TResult>);
      }),
  });
}
